import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { CategoryBadge } from "./CategoryBadge";
import { fmtDate } from "../../lib/format";

export const AnnouncementSidebar = ({ items, hasMore }) => (
  <aside className="bg-white rounded-[2rem] border border-black/5 shadow-sm p-6 sm:p-7 flex flex-col h-full" data-testid="announcement-sidebar">
    <p className="eyebrow text-[#E07A5F] mb-3" data-testid="sidebar-title">Duyurular</p>
    {items.length === 0 && <p className="text-sm text-slate-500" data-testid="sidebar-empty">Henüz duyuru yok.</p>}
    <ul className="flex-1 divide-y divide-black/5">
      {items.map((a, i) => (
        <li key={a.id} className="fade-up" style={{ animationDelay: `${i * 50}ms` }}>
          <Link to={`/duyuru/${a.id}`} className="group flex items-start gap-3 py-3" data-testid={`sidebar-item-${a.id}`}>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <CategoryBadge category={a.category} />
                <span className="text-[11px] text-slate-400">{fmtDate(a.date)}</span>
              </div>
              <p className="text-sm font-semibold text-slate-800 leading-snug line-clamp-2 group-hover:text-[#1B4332] transition-colors">{a.title}</p>
            </div>
            <ChevronRight size={16} className="mt-6 text-slate-300 group-hover:text-[#E07A5F] group-hover:translate-x-0.5 transition-transform" />
          </Link>
        </li>
      ))}
    </ul>
    {hasMore && (
      <Link to="/duyurular" className="mt-3 text-sm font-bold text-[#E07A5F] hover:underline" data-testid="sidebar-more-link">daha fazla...</Link>
    )}
  </aside>
);
